(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documents', {
            parent: 'application',
            url: '/documents',
            data: {
                pageTitle: 'global.menu.documents'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/documents/documents.html',
                    controller: 'DocumentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documents');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
